export const COMPACT_SELECT = {
    fontSize: 11,
    '& .MuiSelect-select': {
        py: 0.375,
        minHeight: 'unset',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0,
        lineHeight: 1.3,
        overflow: 'hidden',
        '& > *': {
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
};

export const COMPACT_ITEM = {
    fontSize: 11,
    minHeight: 'unset',
    py: 0.375,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0,
    lineHeight: 1.3,
    overflow: 'hidden',
    '& > *': {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

export const workingButtonSx =
    (isWorking: boolean, variant: 'outlined' | 'contained' = 'outlined') =>
    (theme: {
        palette: {
            primary: { main: string; contrastText: string };
            action: { hover: string };
        };
    }) => ({
        fontSize: 11,
        ...(isWorking &&
            (variant === 'contained'
                ? {
                      '&.Mui-disabled': {
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.primary.contrastText,
                      },
                      '@keyframes replanningWorkingFilled': {
                          '0%, 100%': { opacity: 1 },
                          '50%': { opacity: 0.72 },
                      },
                      animation:
                          'replanningWorkingFilled 1.6s ease-in-out infinite',
                  }
                : {
                      '&.Mui-disabled': {
                          color: theme.palette.primary.main,
                          borderColor: theme.palette.primary.main,
                      },
                      '@keyframes replanningWorking': {
                          '0%, 100%': { backgroundColor: 'transparent' },
                          '50%': {
                              backgroundColor: theme.palette.action.hover,
                          },
                      },
                      animation: 'replanningWorking 1.6s ease-in-out infinite',
                  })),
    });
